import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingEventHandler {
  private loadingEventSubject = new Subject<boolean>();

  notifyLoading(isBusy: boolean) {
    this.loadingEventSubject.next(isBusy);
  }

  onLoadingRequested() {
    return this.loadingEventSubject.asObservable();
  }
}
